import {
	GET_PUBLICATION_SHARE_DATA,
	GET_PUBLICATION_FORM,
	FORM_AUTH
} from "../actions/CompanyPublicationShareActions";
import _ from "lodash";

const POLAR_OPTIONS = [
	{ value: "POLAR_YES", label: "Yes" },
	{ value: "POLAR_NO", label: "No" }
];

const DEFAULT_FORM = {
	anonymous: false,
	requiredIdentification: [],
	active: false,
	sign: false,
	questions: []
};

const convertRadioToPolar = question => {
	if (
		question.type === "RADIO" &&
		_.isEqual(question.options, POLAR_OPTIONS)
	) {
		question.type = "POLAR";
	}

	return question;
};

const Share = (state = { form: Object.assign({}, DEFAULT_FORM) }, action) => {
	switch (action.type) {
		case GET_PUBLICATION_SHARE_DATA + "_FULFILLED":
			return {
				...state,
				data: action.payload.body
			};

		case FORM_AUTH + "_FULFILLED":
			return {
				...state,
				auth: action.payload.body.Password
			};

		case GET_PUBLICATION_FORM + "_FULFILLED":
			action.payload.body.questions = action.payload.body.questions.map(
				convertRadioToPolar
			);
			return {
				...state,
				form: action.payload.body
			};

		default:
			return state || false;
	}
};

export default Share;
